//React
import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as communityKeywordAction from '../action/communityKeywordAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
import * as myKeywordAction from '../action/myKeywordAction';

//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';

//Part
import PartUserName from './PartUserName';
import PartUserMainImg from './PartUserMainImg';
import PartPagingNextPrev from './PartPagingNextPrev';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon
import CloseIcon from '@material-ui/icons/Close';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';




class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      keywordAddText: null,
  	}
  }

  _listGet(page) {
    this.props.communityKeywordUserListGet(this.props.communityKeyword.userListKeyword, page, this.props.communityKeyword.userListTimestamp);
    document.getElementById('community_keyword_user_list_block').scrollTo(0, 0);
  }


  _keywordAddSubmit(keyword) {
    this.props.mykeywordAdd(keyword, () => {
      this.setState({keywordAddText: null});
    });
  }


  _renderList(value, index, arr) {
    return (
      <div key={index}>
        <div style={{padding:'3px'}}>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >
            <div style={{margin:'3px'}}>
              <Link
                to={{ pathname: '/partner/' + value.userdata_id_code}}
              >
                <PartUserMainImg
                  mainImg={value.userdata_mainImg}
                  width={'40px'}
                  height={'40px'}
                  radius={'50%'}
                />
              </Link>
            </div>
            <div style={{flex:1}}>
              <Link
                to={{ pathname: '/partner/' + value.userdata_id_code}}
              >
                <PartUserName
                  data={{
                    name: value.userdata_name,
                    sex: value.userdata_sex,
                    size: '1.2em',
                  }}
                />
              </Link>
              <div>
                {value.userdata_age}才 {value.userdata_prof_region}
              </div>
            </div>
            <div>
              <div>
                <IconButton
                  onClick={ () => this.props.partnerOperationOpen(value.userdata_id_code, ['nondisplay','refusal','memo']) }
                >
                  <MoreVertSharpIcon />
                </IconButton>
              </div>
            </div>
          </div>
        </div>
        {
          (arr.length - 1 > index) &&
          <Divider />
        }
      </div>
    )
  }

	render() {
    let registered = this.props.my.keyword.find((v) => v.text === this.props.communityKeyword.userListKeyword);

		return (
    <>
      <Dialog
        fullScreen
        open={this.props.open}
        onClose={ () => {
          this.setState({list:[]});
          this.props.close();
        }}
        style={{maxWidth:'400px', margin:'auto'}}
      >
        <div
          style={{
            width:'100%',
          }}
        >
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              textAlign:'center',
              alignItems:'center',
              justifyContent:'space-between',
              background:'#FFF',
            }}
          >
            <div style={{margin:'10px', textAlign:'left'}}>
              キーワードに「{this.props.communityKeyword.userListKeyword}」を登録している会員
            </div>

            <div>
              <IconButton
                onClick={ () => {
                  this.setState({list:[]});
                  this.props.close();
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </div>
        <div
          id='community_keyword_user_list_block'
          style={{
            overflowY:'auto',
            WebkitOverflowScrolling: 'touch',
          }}
        >
        {
          (this.props.my.proof.credit === 0 && this.props.my.proof.person === 0) ? (
            <div  align='center'>
              <h2 align='center'>本人証明が申請されていない為<br/>閲覧できません</h2>
              <div align='center' style={{padding:'10px'}}>
                <Link
                  to={{ pathname: '/my/proof/person'}}
                >
                  <Button
                    variant="contained"
                    color='secondary'
                  >
                    <div>
                      <div style={{fontSize:'1.4em'}}>本人証明を申請する</div>
                      <div>1分ほどで簡単に登録できます</div>
                    </div>
                  </Button>
                </Link>
              </div>
            </div>
          ): (
            <>
              {
                (registered) ? (
                  null
                ):(
                  <div style={{margin:'5px'}}>
                    <u
                      className='link'
                      onClick={ () => this.setState({keywordAddText: this.props.communityKeyword.userListKeyword}) }
                    >
                      「{this.props.communityKeyword.userListKeyword}」を自分のプロフに追加
                    </u>
                  </div>
                )
              }
              {
                (this.props.communityKeyword.userList.length > 0) ? (
                  this.props.communityKeyword.userList.map((value, index, arr) =>
                    this._renderList(value, index, arr)
                  )
                ) : (
                  <div style={{margin:'10px'}}>該当する会員はみつかりませんでした</div>
                )
              }
              <div style={{margin:'5px'}}>
                <PartPagingNextPrev
                  page={this.props.communityKeyword.userListPage}
                  isNext={this.props.communityKeyword.userIsListNext}
                  onClick={ (e) => this._listGet(e) }
                />
              </div>
            </>
          )
        }
        </div>
      </Dialog>

      <DialogConfirm
        open={ (this.state.keywordAddText) ? true : false }
        title={'キーワードの追加'}
        content={ (
          <>
            <div>{'プロフィールのキーワードに'}</div>
            <div>{'"' + this.state.keywordAddText + '" を追加しますか？'}</div>
          </>
        )}
        apply={ () => {
          this._keywordAddSubmit(this.state.keywordAddText);
        }}
        close={ () => this.setState({keywordAddText: null}) }
      />
    </>
		)
	}
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
    communityKeyword: state.communityKeyword,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...communityKeywordAction,
    ...partnerOperationAction,
    ...myKeywordAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
